<div class="flex justify-content-center align-items-center text-xl font-bold" *ngIf="onExtendedMobile()">
	{{ 'EVENTS' | translate }}
</div>
<div class="layout-content">
	<p-blockUI [blocked]="blockedDocument" />
	<div class="grid">
		<div *ngIf="exporting">
			<div class="flex align-items-center justify-content-center w-full"
				style=" position: fixed; z-index: 999; text-align: center;">
				<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
			</div>
		</div>
		<app-events-filters class="col-12 pt-0"></app-events-filters>
		<div class="card col-12 border-round">
			<app-events-table></app-events-table>
		</div>
	</div>
</div>